"use client"

import { FC } from "react"
import { TopBanner } from "components/layout/TopBanner"

export const BackToSchoolBanner: FC = () => {
    return (
        <TopBanner name="promo-back-to-school-2025" dismissible={true} className="bg-primary-950">
            <strong className="font-semibold">Code: BACKTOSCHOOL</strong>
            <svg viewBox="0 0 2 2" className="mx-2 inline h-0.5 w-0.5 fill-current" aria-hidden="true">
                <circle cx={1} cy={1} r={1} />
            </svg>
            Get <span className="font-semibold">20% off</span> all course recordings. Ends 12th Sep. Intros:{" "}
            <a
                className="underline decoration-white/70 underline-offset-2 hover:decoration-white"
                href="/academy/videos/copilot-intro"
            >
                Copilot
            </a>
            {" / "}
            <a
                className="underline decoration-white/70 underline-offset-2 hover:decoration-white"
                href="/academy/videos/chatgpt-intro"
            >
                ChatGPT
            </a>
            {" · "}
            <a
                className="underline decoration-white/70 underline-offset-2 hover:decoration-white"
                href="/academy/course-recordings"
            >
                browse advanced (90‑min)
            </a>
        </TopBanner>
    )
}

export default BackToSchoolBanner
